// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-62143652]:export {\n  menuBg: white;\n  menuText: rgba(0, 0, 0, 0.65);\n  menuActiveText: #005BB5;\n}\n\n/* Mixins */", ""]);
// Exports
module.exports = exports;
